import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export interface LayerState {
  layers: string[];
}

const initialState: LayerState = {
  layers: [], // зажатая клавиша
};

const layerSlice = createSlice({
  name: "layerSlice",
  initialState,
  reducers: {
    pushLayer: (state, action: PayloadAction<string>) => {
      state.layers =
        state.layers.at(-1) !== action.payload
          ? [...state.layers, action.payload]
          : [...state.layers];
    },
    popLayer: (state) => {
      const layers = [...state.layers];
      layers.pop();
      state.layers = layers;
    },
  },
});

export const layersSelector = (state: RootState) => state.layer.layers;
export const currLayerSelector = (state: RootState) => state.layer.layers.at(-1);

export const layerReducer = layerSlice.reducer;
export const { pushLayer, popLayer } = layerSlice.actions;
